module.exports = __webpack_public_path__ + "img/21.1.b788a1d8.jpg";